import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from '../components/layout/DashboardLayout';
import Dashboard from '../pages/dashboard/Dashboard';
import UserManagement from '../pages/users/UserManagement';
import UserDetails from '../pages/users/UserDetails';
// import Settings from '../pages/settings/Settings';
import Login from '../components/auth/Login';
import ProtectedRoute from '../components/auth/ProtectedRoute';
import ChangePassword from '../components/auth/ChangePassword';
import ForgotPassword from '../components/auth/ForgotPassword';
import ResetPassword from '../components/auth/ResetPassword';
import Leads from '../pages/Leads/Leads';
import ApplyLoan from '../pages/apply-loan/ApplyLoan';
import LoanApplicationSuccess from '../pages/apply-loan/LoanApplicationSuccess';
import Loans from '../pages/loans/Loans';
import Profile from '../pages/profile/Profile';
import CreateLoanProposal from '../pages/proposals/CreateLoanProposal';
import LenderProposals from '../pages/proposals/LenderProposals';
import ProposalDetails from '../pages/proposals/ProposalDetails';
import PublishBlogMaster from '../pages/Blogs/PublishBlogMaster';
import Proposals from '../pages/proposals/Proposals';
import Offers from '../pages/offers/Offers';
import OfferDetails from '../pages/offers/OfferDetails';

const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:uuid/:token" element={<ResetPassword />} />
            <Route path="/reset-forgot-password/:uuid/:token" element={<ResetPassword />} />            
            <Route path="/" element={<Navigate to="/login" replace />} />

            <Route
                path="/"
                element={
                    <ProtectedRoute>
                        <DashboardLayout />
                    </ProtectedRoute>
                }
            >
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="users" element={<Navigate to="/users/managers" replace />} />
                <Route path="users/managers" element={<UserManagement userType="manager" />} />
                <Route path="users/consultants" element={<UserManagement userType="consultant" />} />
                <Route path="users/borrowers" element={<UserManagement userType="borrower" />} />
                <Route path="users/managers/:uuid" element={<UserDetails />} />
                <Route path="users/consultants/:uuid" element={<UserDetails />} />
                <Route path="users/borrowers/:uuid" element={<UserDetails />} />
                <Route path="profile" element={<Profile />} />
                <Route path="change-password" element={<ChangePassword />} />
                <Route path="leads" element={<Leads />} />
                <Route path="apply-loan" element={<ApplyLoan />} />
                <Route path="loan-application-success" element={<LoanApplicationSuccess />} />
                <Route path="proposals" element={<Loans />} />
                <Route path="loans" element={<Navigate to="/proposals" replace />} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
                <Route path="users/lenders" element={<UserManagement userType="lender" />} />
                <Route path="users/lenders/:uuid" element={<UserDetails />} />
                <Route path="create-proposal/:applicationId" element={<CreateLoanProposal />} />
                {/* <Route path="proposals" element={<Proposals />} /> */}
                <Route path="proposals/lender/:uuid" element={<LenderProposals />} />
                <Route path="proposals/details/:uuid" element={<ProposalDetails />} />
                <Route path="blogs" element={<PublishBlogMaster/>} />
                <Route path="offers" element={<Offers />} />
                <Route path="offers/:id" element={<OfferDetails />} />
            </Route>
        </Routes>
    );
};

export default AppRoutes;